<template>
  <div class="ui stackable grid">
    <div id="loader" class="ui active dimmer" v-if="loading">
      <div class="ui text loader">Loading</div>
    </div>
    <div class="sixteen wide column">

      <div class="ui success message" v-if="accountClaimed">
        <i class="close icon" @click="dismissModal"></i>
        <div class="header">
          You have claimed your account
        </div>
        <p>You may now log-in with the email and password that you have submitted. If you lose or forgot the password then you can reset your password.</p>
      </div>

      <div class="ui placeholder segment" v-if="isAnonymous">
        <h2 class="ui header">
          <i class="key icon"></i>
          <div class="content">
            Claim your account
          </div>
          <div class="sub header">
            You're using a guest account right now and won't be able to access this content again unless you claim your account.
          </div>
        </h2>

        <div class="ui form">
          <div class="fields">
            <div class="field four wide">
              <label>Your Email</label>
              <div class="ui fluid input">
                <input type="text" placeholder="your-email@website.com" v-model="email">
              </div>
            </div>
            <div class="field four wide">
              <label>Your Password</label>
              <div class="ui fluid input">
                <input type="password" placeholder="password you'll remember here" v-model="password">
              </div>
            </div>
            <div class="field">
              <label></label><br />
              <div class="ui fluid input">
                <div :class="{'ui primary button': true, 'disabled': !isClaimEnabled}" :disabled="!isClaimEnabled"  @click="claimAccount">
                  Claim
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui stackable grid form">
        <div class="column eight wide">
          <div class="ui segment">
            <h2>Your Account</h2>
            <div class="field wide">
              <label>Your User ID</label>
              <div class="ui fluid input">
                <input type="text" disabled="disabled" v-model="userId">
                <!-- <button class="ui teal right icon button">
                  Copy
                  <i class="copy icon"></i>
                </button> -->
              </div>
            </div>
            <div class="wide field" v-if="!isAnonymous">
              <label>Your Email</label>
              <div class="ui fluid input">
                <input type="text" disabled="disabled" v-model="email">
              </div>
            </div>
            <div class="wide field" v-if="!isAnonymous">
              <label>Account Nickname</label>
              <div class="ui action fluid input">
                <input type="text" v-model="mainAccount.name" @focus="dirtyName = true">
                <button :class="{'ui icon button': true, 'red': dirtyName}" @click="saveNickname()">
                  <i class="save icon"></i>
                </button>
              </div>
            </div>
            <div class="wide field">
              <label>Actions</label>
              <div class="ui input">
                <router-link to="/welcome" class="ui button"><i title="welcome" class="info icon"></i> Guide</router-link>
                <button class="ui button" @click="logout" v-if="user"><i title="welcome" class="sign-out icon"></i> Logout</button>
              </div>
            </div>
          </div>
        </div>
          <div class="column eight wide" v-if="!isAnonymous">
            <div class="ui segment">
              <div class="wide field">
                <h2>Accounts</h2>
                <table class="ui celled striped table table-responsive">
                  <thead>
                  <th>Status</th>
                  <th>
                    Account Name
                  </th>
                  <th>
                    Actions
                  </th>
                  </thead>
                  <tbody>
                  <tr v-for="(curAccount, index) in account" :key="index" class="item">
                    <td>
                      <i class="icon eye" v-if="mainAccount.default_account == curAccount.id"></i>
                      <i class="icon low vision" v-if="mainAccount.default_account != curAccount.id"></i>
                    </td>
                    <td>
                      {{curAccount.name}}
                    </td>
                    <td>
                      <a class="ui label" @click="setDefaultAccount(curAccount.id)" v-if="mainAccount.default_account != curAccount.id">
                        Set as Default
                      </a>
                      <a class="ui label red" @click="setDefaultAccount(mainAccount.id)" v-if="mainAccount.default_account == curAccount.id && curAccount.id != mainAccount.id">
                        Remove As Default
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <h2>Share Settings</h2>
              <div class="wide field">
                <label>Share My Account With...</label>
                <table class="ui celled striped table table-responsive">
                  <thead>
                  <th>
                    Account ID
                  </th>
                  <th>
                    Actions
                  </th>
                  </thead>
                  <tbody>
                    <tr v-for="(curAccount, index) in mainAccountUsers" :key="index">
                      <td>
                        {{curAccount}}
                      </td>
                      <td>
                        <a class="icon button" @click="unshareAccount(curAccount)"><i class="red minus circle icon"></i></a>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="ui action fluid input">
                  <input type="text" placeholder="Ask for the user ID from the person you want to share with" v-model="shareWithUser">
                  <button class="ui icon button" @click="shareAccount()">
                    <i class="plus icon"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- <div class="ui segment">
              <h2>Your Galleries</h2>
              <p>These are used to create groups of items for organization or to share</p>
              <table v-if="galleries.length > 0" id="gallery-table" class="ui celled striped table table-responsive">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Items</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(curGallery, index) in galleries" :key="index">
                    <td>{{curGallery.id}}</td>
                    <td>{{curGallery.name}}</td>
                    <td>{{curGallery.items.length}}</td>
                    <td>
                      <router-link :to="{ name: 'Item', 'params': {id: curGallery.id}}" class="ui button">
                        <i class="eye icon"></i>
                        View
                      </router-link>
                      <div class="ui button" @click="editGallery(curGallery)">
                        <i class="box icon"></i>
                        Edit
                      </div>
                      <div class="ui button" @click="archiveGallery(curGallery)">
                        <i class="box icon"></i>
                        Archive
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div :class="{'ui primary button': true}" :hidden="galleries.length > 0" @click="editGallery(gallery)">
                Add New Gallery
              </div>
            </div> -->
          </div>
        </div>
      </div>

    <div class="ui mini modal">
      <i class="close icon"></i>
      <div class="header">
          {{modalHeader}}
      </div>
      <div class="content">
        <div class="ui form">
          <div class="field twelve wide">
            {{modalMessage}}
          </div>
          <div class="field">
            <label></label><br />
            <div class="ui fluid input">
              <div class="ui primary button" @click="doModalAction">
                Confirm
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as firebase from 'firebase'
import { mapGetters } from 'vuex'
export default {
  name: 'Account',
  components: {
  },
    data() {
        return {
          userId: "",
          email: "",
          password: "",
          isAnonymous: false,
          accountClaimed: false,
          shareWithUser: "",
          modalHeader: "",
          modalMessage: "",
          modalAction: async function() {},
          gallery: {
            id: "-1",
            name: "",
            users: []
          },
          dirtyName: false,
          loading: false
        };
    },
    mounted() {
      this.userId = this.user.uid
      if (firebase.auth().currentUser.isAnonymous && !this.user.email) {
        this.isAnonymous = true
      }
      else {
        this.email = this.user.email
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        // galleries: 'GalleryModule/get',
        account: 'AccountModule/get',
      }),
      mainAccount: function() {
        if (this.account.length == 0) {
          return {id: this.user.uid, default_account: this.user.uid, users: []}
        }
        return this.account.find(account => account.id = this.user.uid)
      },
      sharedAccounts: function() {
        return this.account.filter(account => account.id != this.user.uid)
      },
      mainAccountUsers: function() {
        if (this.account.length == 0) {
          return []
        }
        return this.mainAccount.users
      },
      isClaimEnabled: function() {
        return this.isAnonymous && !this.email == "" && !this.password == ""
      }
    },
    methods: {
      logout: function () {
        this.$store.commit('logout')
      },
      claimAccount: function() {
        var cred = firebase.auth.EmailAuthProvider.credential(this.email, this.password);
        firebase.auth().currentUser.linkWithCredential(cred);
        this.isAnonymous = false
        this.accountClaimed = true
      },
      dismissModal: function() {
        this.accountClaimed = false
      },
      editGallery: function(gallery) {
        this.gallery = gallery
        this.openModal()
      },
      saveGallery: async function() {
        this.loading = true
        if (this.gallery.id == "-1") {
          await this.$store.dispatch('GalleryModule/create', this.gallery)
        } else {
          await this.$store.dispatch('GalleryModule/save', this.gallery)
        }
        this.resetGallery()
        window.jQuery('.ui.modal').modal('hide')
        this.loading = false
      },
      shareGallery: async function() {
        await this.$store.dispatch('GalleryModule/shareGallery', {gallery: this.gallery, user: this.shareWithUser})
        this.shareWithUser = ""
      },
      // unshareGallery: async function(user) {
      // switch to doConfirm
      //   if (doConfirm("Are you sure you want to remove sharing with " + user + "?")) {
      //     await this.$store.dispatch('GalleryModule/unshareGallery', {gallery: this.gallery, user: user})
      //   }
      // },
      shareAccount: async function() {
        await this.$store.dispatch('AccountModule/share', {account: this.mainAccount, user: this.shareWithUser})
        this.shareWithUser = ""
      },
      unshareAccount: async function(user) {
        await this.doConfirm("Account Sharing", "Are you sure you want to remove sharing with " + user + "?", async function(store) {
          await store.dispatch('AccountModule/unshare', {account: this.mainAccount, user: user})
          window.jQuery('.ui.modal').modal('hide')
        })
      },
      doModalAction: async function() {
        this.modalAction(this.$store)
      },
      doConfirm: async function(header, message, action) {
        this.modalHeader = header
        this.modalMessage = message
        this.modalAction = action
        window.jQuery('.ui.modal').modal('show')
      },
      saveNickname: function() {
         this.$store.dispatch('AccountModule/save', {id: this.mainAccount.id, name: this.mainAccount.name})
         this.dirtyName = false
      },
      setDefaultAccount: async function(accountId) {
        this.loading = true
        let dynamicWhere = [['created_by', '==', accountId]]
        await this.$store.dispatch('ItemModule/closeDBChannel')
        await this.$store.dispatch('PhotoModule/closeDBChannel')

        await this.$store.dispatch('ItemModule/openDBChannel', { where: dynamicWhere })
        await this.$store.dispatch('PhotoModule/openDBChannel', { where: dynamicWhere })
        await this.$store.dispatch('AccountModule/setDefaultAccount', {account: this.mainAccount, accountId: accountId})
        this.loading = false
      },
      // archiveGallery: async function(gallery) {
      // switch to doConfirm
      //   if (doConfirm(`Are you sure you want to archive ${gallery.name}?`)) {
      //     this.loading = true
      //     await this.$store.dispatch('GalleryModule/archive', {id: gallery.id})
      //     this.loading = false
      //   }
      // },
      resetGallery: function() {
        this.gallery = {
            id: "-1",
            name: "",
            users: []
          }
      },
      openModal: function() {
        window.jQuery('.ui.modal').modal('show')
      },
    }
}
</script>

<style scoped>
</style>
